
import MusicDashboard from "../../../assets/duotone/MusicDashboard.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MusicDashboardIcon({ className, dataTestid = "MusicDashboardIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MusicDashboard data-testid={dataTestid} className={classes} {...rest} />
  );
}
